import React, { useState } from "react";
import styles from "./teachers.module.css";

import { Box, Link, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Head from "next/head";
import MysteryBannerNew from "../../components/MysteryBannerNew/MysteryBannerNew";

export default function Index() {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  return (
    <>
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <div className={styles.rotathewheelblockone}>
        {/* {/ <!------Main Banner section-------> /} */}
        <div className={styles.asmainwrapper}>
          <div className={styles.rotathewheelblockoneleft}>
            <div className={styles.bannerLogo}>
              <span className={styles.logoviewlink} onClick={handleOpen}>
                {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/viewicon.png" /> */}
                <img
                  src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                />
              </span>
              {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" /> */}
              <img
                src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
              />
            </div>
            <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
            <h1 data-text="infinite being">INFINITE BEING</h1>

            <h2>Polytheistic Monism - Divine Theurgy - Oracle to the Gods</h2>
            <div
              className={`${styles.rotathewheelbottombannerbg} ${styles.bannerboxtxt}`}
            >
              <div className={styles.yellow_bar}></div>
            </div>
          </div>
        </div>
      </div>
      
      <MysteryBannerNew/>

      <div className={styles.teachers_fast_wrapper}>
        <div className={styles.teachers_blk1_main_wrapper}>
          <div className={styles.common_1width}>
            <div
              className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle} `}
            >
              <span className={styles.column}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h1>
                    TEACHER AND PRACTITIONER OF THE <br />
                    DIVINE INFINITE BEING METHOD
                  </h1>
                </div>
              </span>
            </div>
          </div>

          <div className={styles.full_block_wrapper}>
            <div className={styles.common_width}>
              <div className={styles.ritual_praxis_main_body}>
                <div
                  className={`${styles.block2_full_width} ${styles.block2_new_full_width}`}
                >
                  <div className={styles.ritual_praxis_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_1lst_img.webp"/> */}

                      <img className={styles.block2_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_1lst_img.webp`} />
                    </div>
                    <div className={styles.ritual_praxis_text_box}>
                      <div className={styles.ritual_praxis_text_box_bfr}>
                        <div className={styles.border_box}></div>
                        <div className={styles.yellow_heading}>
                          <h1>INTRODUCTION TO THE BIO OF EDDIE PAREDES</h1>
                        </div>
                        <div className={styles.ritual_praxis_text_box_bfr}>
                          <p>
                            Writing one’s own BIO is something that everyone
                            should do, and it does not tend to be a simple task
                            for anyone. This BIO is not exactly chronological,
                            but it is fairly complete. For those of you here to
                            see who your teacher is for the Astrology/Tarot
                            courses you will find much to review here. This BIO
                            is made for those entering our school from the many
                            different levels be that as members, alumni
                            (certificate graduates) or aspirants to the inner
                            order.{" "}
                            <span>
                              I am one of two teachers in the Astrology/Tarot 12
                              week certification course
                            </span>
                            . You can see that here. I am also the Head Master
                            of the inner mystery school and your teacher and
                            guide in either case. Let me introduce myself and
                            give you some history.{" "}
                          </p>

                          <p>
                            I am a highly curious individual with a passion for
                            academic research and direct experiential practice.
                            I study endlessly and always make it an imperative
                            to read for at least an hour a day. I take frequent
                            breaks from my company just to study for several
                            days in a row every month.{" "}
                            <span>
                              I’ve done this fairly consistently for over 20
                              years as I have owned and operated my own company
                              since 2004
                            </span>
                            .
                          </p>
                          <p>
                            Although I have spent a lot of time with different
                            occult orders and spiritual groups at different
                            times, I have spent most of my life as a solitary
                            spiritual seeker. As a solitary I have practiced
                            everything from Chi Gong to Yoga to Ceremonial
                            Magick and have kept a keen interest in the quantum
                            sciences, the history of ideas and modern approaches
                            to psychology and consciousness. Over the better
                            part of my practices I have focused on the art and
                            science of Theurgy, Astrology, Tarot and what we
                            term <span>“craft”</span> (related to Neoplatonic
                            Hecate based witchcraft). Being solitary but highly
                            active has allowed me to develop a unique program
                            that has come from the most effective of what I have
                            studied and experienced.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block1_full_width}>
                  <div className={styles.ritual_praxis_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                        className={styles.block1_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_2nd_img.webp"
                      /> */}
                      <img className={styles.block1_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_2nd_img.webp`} />
                    </div>
                    <div className={styles.ritual_praxis_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.ritual_praxis_text_box_bfr}>
                        <p>
                          Although you can find several articles and the
                          framework of our programs in our Central Doctrine, my
                          life work culminates around the predicates of{" "}
                          <span>
                            Quantum Mechanics, String Theory, Jungian
                            Psychology, the work of Philosopher Timothy Desmond
                            the occult and Theurgic application of the Divine
                            Arcana Tarot
                          </span>
                          . Our inner mysteries are focused on the incorporation
                          of these models into a Theurgic ritual praxis central
                          to the Divine Arcana Tarot itself. You can see a full
                          color, high DPI version of the deck here.
                        </p>

                        <p>
                          I am a very big believer in the development of a
                          spiritual community and so are the protagonists of our
                          school. The advantage of being solitary for so long
                          allowed me to keep a very open perspective. Now after
                          working at this school for over two decades I am
                          looking to bring my tribe home :). I hope my BIO and
                          our available literature finds a place in your heart
                          and you join our cause. The kingdom of the Divine
                          Infinite Being and the raising of the great oracle
                          beacons those that find their way to our work. So who
                          am I to offer this path to the members of our school?
                        </p>

                        <p>
                          I currently own and operate a medical bioinformatics
                          engineering and software development company with 42
                          employees and several partners. For 22 years much of
                          the creativity and mastery I continued through the
                          occult sciences centered around our company and its
                          current state and growth.{" "}
                          <span>
                            We have launched over 2,500 projects with major
                            initiatives for 7 of the INC 500
                          </span>
                          . We have earned millions of dollars over the
                          lifecycle of our initiatives and throughout I
                          incorporated Astrology, Tarot, meditation, ritual,
                          prayer and advanced forms of what is popularly known
                          as “the power of attraction”. To say the least I have
                          experienced overwhelming results in these areas. For a
                          look at my professional resume and company please
                          visit{" "}
                          <Link href="mailto:www.BetoParedes.com">
                            www.BetoParedes.com
                          </Link>{" "}
                          .
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block2_full_width}>
                  <div className={styles.ritual_praxis_box_wrpr2}>
                    <div
                      className={`${styles.img_box} ${styles.trfm_Y1}  ${styles.trfm_Y2}`}
                    >
                      {/* <img
                        className={styles.block3_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_3rd_img.webp"
                      /> */}
                      <img className={styles.block3_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_3rd_img.webp`} />
                    </div>
                    <div className={styles.ritual_praxis_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.ritual_praxis_text_box_bfr}>
                        <p>
                          I have always worked to live an ascetic life from the
                          time I was a teenager. I really have my father to
                          thank for this. He was a great example to me when I
                          was young of a super hard working man with little to
                          no attachments. I fell in love with Stoicism and
                          living a minimalist lifestyle focused on academics and
                          experience over material gain. Most if not all of my
                          money has been reinvested back into my businesses or
                          spent on the requirements of our school.{" "}
                          <span>
                            For the school I have amassed a large library of
                            over 1,600 volumes, many of them rare or out of
                            print
                          </span>
                          . I have an online search coming soon where you can
                          see what is in this library. I host researchers and
                          seekers who want to access this first hand.
                        </p>

                        <p>
                          I have a healthy habit of playing guitar and through
                          my lifetime have been in 13 different bands. Music is
                          a huge influence in my life and is part of my
                          philosophical worship of Apollo. Next to the practices
                          of Theurgy this has been a major expression of my art
                          to life. It used to be a very serious endeavor and now
                          is just a companion to the Universal laws of
                          experience for me personally.{" "}
                        </p>

                        <p>
                          Although I have no deep opinion of the food eaten by
                          others I have chosen to eat a very clean zero carb
                          carnivore diet.{" "}
                          <span>
                            I try to only eat once a day and I fast every full
                            and new moon
                          </span>
                          . I mention diet here because it is of critical
                          importance to me and something I stress within the
                          inner mystery School of Our Divine Infinite Being.
                          There are hundreds of healthy and valid ways to manage
                          one's diet. Over the years I have successfully engaged
                          with other dietary programs. Whether you are a meat
                          eater, keto, or a fan of starchy foods, if you do not
                          manage your diet as a discipline, life will be
                          miserable. There are many great and free resources
                          available today and whatever you follow you should be
                          absolute and resolved to stay healthy.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.teachers_blk2_main_wrapper}>
          <div className={styles.common_1width}>
            <div
              className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle} `}
            >
              <span className={styles.column}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h1>MY PERSONAL THEURGIC AND RELIGIOUS OUTLOOK</h1>
                </div>
              </span>
            </div>
          </div>
          <div className={styles.full_block2_wrapper}>
            <div className={styles.common_width}>
              <div className={styles.ritual_praxis_main_body}>
                <div className={styles.block1_full_width}>
                  <div className={styles.ritual_praxis_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                        className={styles.block1_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_block2_1st_img.webp"
                      /> */}
                      <img className={styles.block1_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_block2_1st_img.webp`} />
                    </div>
                    <div className={styles.ritual_praxis_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.ritual_praxis_text_box_bfr}>
                        <p>
                          My personal practices as a Theurgist centers around a
                          syncretism of Chaldean,{" "}
                          <span>
                            Greek, Roman and Hindu Mysteries blended with
                            Astrology, philosophic witchcraft craft and the
                            personification of the spirits of nature
                          </span>
                          . As complex as this may sound, our Greater Arcana
                          Tarot represents this parsimoniously and our school
                          gives very straight forward instruction for engagement
                          through ritual praxis. I, and thereby our school,
                          follows Polytheistic Monism, finding deep meaningful
                          expressions in all of the world's spiritual and
                          religious narratives. As a philosophical framework
                          this is an expression of the Perennial Philosophy. You
                          can learn more about this in our Central Doctrine.{" "}
                        </p>

                        <p>
                          I find the tenets of Animism (nature as alive with
                          spiritual agency) to be an extremely vital part of my
                          personal awareness and believe it to be at the core of
                          all <span>“experiences of the spirit”</span> in
                          religious practices. Whether this be the{" "}
                          <span>“holy spirit”</span> of the Christian or{" "}
                          <span>“the spirits of nature”</span> of Shamanic
                          practices, I have personally experienced them all to
                          be the same thing. The Platonists called this the
                          Anima Mundi, the spiritual soul of the earth, the
                          “whispering spirit” that communicates to us through
                          dreams and experiences with nature.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.block2_full_width} ${styles.block2_new_blk1_full_width}`}
                >
                  <div className={styles.ritual_praxis_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_bnlock2_2nd_img_new.webp"
                      /> */}
                      <img className={styles.block2_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_bnlock2_2nd_img_new.webp`} />
                    </div>
                    <div className={styles.ritual_praxis_text_box}>
                      <div className={styles.ritual_praxis_text_box_bfr}>
                        <div className={styles.border_box}></div>

                        <div className={styles.ritual_praxis_text_box_bfr}>
                          <p>
                            At least once a week during the warm months I spend
                            time on the Snake River for meditation and to
                            connect with the river spirits. Our school’s main
                            locations are in St. Anthony, ID and Salt Lake City,
                            UT. The snake river runs directly through my
                            hometown and I have a deep connection to its natural
                            center of power. I often will sit right in the river
                            with the water up to my chest meditating on Gaea,
                            Shakti and the spiritual flow of this divine river
                            valley. Several full and new moons I have entered
                            and spent time in the river bottoms solo and with
                            others in ritual drawing down the moon.
                          </p>

                          <p>
                            I have a deep relationship with what I simply call{" "}
                            <span>“Father”</span> of which I meditate upon as
                            the centrality of the One, the Unity, the
                            Singularity, the male creative force. I discourse
                            and pray to <span>“Father”</span> often (all day
                            sometimes) and find the God of the Hebrew and the
                            One of the Platonists to be a very close reflection
                            of this relationship liturgisticly and
                            philosophically. I have an intimate communication
                            with <span>“Father”</span> that I have maintained
                            since I was very young. When thinking about the
                            Father I often reference Hagel's definition of the{" "}
                            <span>“Absolute Spirit”</span>.
                          </p>
                          <p>
                            <i>
                              “The Absolute spirit is considered to be “absolute
                              activity”, it is an active creative element, or,
                              more precisely, creative activity. It permanently
                              moves and develops, and in its self-development
                              creates the whole Universe like the world of
                              continuous formation.”
                            </i>
                          </p>
                          <h5>
                            Spirit and Language in Hegel’s Philosophy of
                            Absolute Spirit Olga B. Panova
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block3_full_width}>
                  <div className={styles.ritual_praxis_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                        className={styles.block1_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_block2_3rd_img.webp"
                      /> */}
                      <img className={styles.block1_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_block2_3rd_img.webp`} />
                    </div>
                    <div className={styles.ritual_praxis_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.ritual_praxis_text_box_bfr}>
                        <p>
                          In the highest regard I, and we at our school, address
                          the totality state of existence as the{" "}
                          <span>“Divine Infinite Being”</span>, or as in the
                          Chaldean Oracles, the “Divine Parent”, both male and
                          female. In totality the highest conception we could
                          ever hold is one of absolute co-equal male/female,
                          god/goddess existence. One of the tenant predicates of
                          our school is to reach this awareness in its eternal
                          and immortal perfect balance. I work with
                          feminine/goddess energies often, especially in ritual.
                          Although this is true, I have found that men nurturing
                          a closer continual relationship with “Father” and
                          women than that of <span>“Mother”</span> can be
                          extremely helpful. Father seems to be most reachable
                          through prayer and dialogue and that of mother through
                          the pure silence of meditation. This is certainly and
                          successfully interchangeable and part of progress in
                          Theurgy it to meditate on father and pray to mother
                          etc.{" "}
                        </p>

                        <p>
                          As best as I can I practice the Banishing ritual of
                          the Pentagram every single morning. I even do this
                          live on camera for those following the school's
                          programs to be able to join me. I perform the invoking
                          Pentagrams at least once a week aligned with the
                          Ochema ritual (I try to do this twice when possible).
                          I perform a grand innovation at the beginning of every
                          Decan (every 10 Astrological days). Although I have
                          practiced hundreds of rituals over the years, I
                          currently follow the exact model that is found in our
                          inner mystery school. At least 3 times a week, and
                          daily when time permits,{" "}
                          <span>
                            I practice Raja-Kundalini with my wife and children
                          </span>
                          .You can see a lot of our rituals and practices in our
                          essays on this website.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.teachers_blk3_main_wrapper}>
          <div className={styles.common_1width}>
            <div
              className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle} `}
            >
              <span className={styles.column}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h1>SHAMANISM AND WITCHCRAFT IS IN MY BLOOD</h1>
                </div>
              </span>
            </div>
          </div>
          <div className={styles.full_block3_wrapper}>
            <div className={styles.common_width}>
              <div className={styles.ritual_praxis_main_body}>
                <div
                  className={`${styles.block2_full_width} ${styles.block2_new_blk1_full_width}`}
                >
                  <div className={styles.ritual_praxis_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_block3_1st_img.webp"
                      /> */}
                      <img className={styles.block2_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_block3_1st_img.webp`} />
                    </div>
                    <div className={styles.ritual_praxis_text_box}>
                      <div className={styles.ritual_praxis_text_box_bfr}>
                        <div className={styles.border_box}></div>

                        <div className={styles.ritual_praxis_text_box_bfr}>
                          <p>
                            Carl Jung’s discovery of the Collective Unconscious
                            uncovered very strong reasons to know your personal
                            Ancestry. Within us are the Archetypal principles
                            found within the experiences of our forefathers,
                            passed on to us from birth. Although bloodline is
                            not all of what makes who you become, I do have an
                            interesting family history. My great grandmother was
                            a full Mapuche native from the Patagonia lands of
                            Chile. Her daughter, my grandmother, raised me and
                            lived with my family until she passed.{" "}
                            <span>
                              The Mapuche never succeeded to the colonial
                              Spanish nor the Chilean government, and are still
                              sovereign to this day
                            </span>
                            . South American Indigenous cultures all recognize
                            Shamanism and Witchcraft as a genuine force of
                            natural spiritual power. I have a deep interest in
                            the history of Witchcraft having studied it for
                            years and the very last witch trial in the Americas
                            was in 1880. This trial was centered around those
                            considered to be practicing Mapuche Witchcraft.
                          </p>

                          <p>
                            Mapuche witchcraft practices were a window for me
                            into the depths of Christian colonial prejudice. The
                            Book <span>“Thunder Shaman”</span>, by Ana Mariella
                            Bacigalupo, is a dialogue between her and a Mapuche
                            “Machi'' the name they use for Shaman or healer. In
                            her discussion she was trying to discern the
                            difference between “Machi” and “Witch” in their
                            culture. The conversation went in circles until
                            finally Machi got frustrated and said “We use the
                            exact same Spirits and connect the exact same
                            powers!” Through more research I discovered the the
                            name of the goddess Kushe (primary in their
                            Pantheon) actually translated to “Witch”.{" "}
                          </p>
                          <p>
                            It was because of the colonial Spanish influences
                            that they began using “Witch” to differentiate those
                            Machi that used spirits and magic against others. In
                            pre-colonial times there were just magic users,
                            sorceresses and “Witch” was a neutral term. Some
                            used it for ill will and others, considered the
                            healers, became known as “Machi”.
                          </p>
                          <p>
                            In this same book the Machi would perform ritual and
                            through dream walking enter into the past of the one
                            being healed and change it. Mapuchi emphasized
                            dreams as the doorway into{" "}
                            <span>“the other world”</span>. Everyone in my
                            family, especially me and my father, have had very
                            intense dream walking experiences. I have seen the
                            future in my dreams on several occasions. This no
                            doubt due to the Archetypal lensing of my ancestors
                            and their work as Mapuchi Machis and witchcraft.{" "}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.teachers_blk4_main_wrapper}>
          <div className={styles.common_1width}>
            <div
              className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle} `}
            >
              <span className={styles.column}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h1>
                    GROWING UP I WAS EXPOSED TO ESOTERIC AND FOLK <br />
                    MAGIC IDEAS THROUGH MY FAMILY’S RELIGION
                  </h1>
                </div>
              </span>
            </div>
          </div>
          <div className={styles.full_block4_wrapper}>
            <div className={styles.common_width}>
              <div className={styles.ritual_praxis_main_body}>
                <div className={styles.block1_full_width}>
                  <div className={styles.ritual_praxis_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                        className={styles.block1_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_block4_1st_img_new.webp"
                      /> */}

                      <img className={styles.block1_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_block4_1st_img_new.webp`} />
                    </div>
                    <div className={styles.ritual_praxis_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.ritual_praxis_text_box_bfr}>
                        <p>
                          I grew up in a highly religious household strict in
                          the disciplines of Theology. My family belonged to a
                          church of <span>“Alternative Christianity”</span> with
                          many occult practices formed in the creative revivals
                          of early America. My ancestors were some of the first
                          members and it forms a major part of my family
                          history. Although I left this world behind, and
                          purposely removed my name from their records, my
                          childhood was filled with their narratives and
                          practices. If I would have stayed a member I would be
                          considered 6th generation today.{" "}
                        </p>

                        <p>
                          Many of their religious principles were taken from
                          esoteric sources including Kabbalah and especially
                          Freemasonry. Not surprising, their founder was proven
                          to be a ceremonial magician, an active mason, and died
                          with the layman of Jupiter around his neck. From his
                          journal entries were found pages of imagery and sigil
                          work taken from <span>“The Magus”</span> by Francis
                          Barret, a publication he had access to based on the
                          famous Heinrich Cornelius Agrippa's occult works. He
                          produced magical operations recorded in full detail
                          that were undeniably initiated through ceremonial
                          means. This was all revealed in a book written by D.
                          Michael Quinn concerning their magical roots in early
                          America. Aleister Crowley even mentioned their founder
                          in a positive light which gave me a laugh when I read
                          it.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  className={`${styles.block2_full_width} ${styles.block2_new_blk1_full_width}`}
                >
                  <div className={styles.ritual_praxis_box_wrpr2}>
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_block4_2nd_img.webp"
                      /> */}
                      <img className={styles.block2_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_block4_2nd_img.webp`} />
                    </div>
                    <div className={styles.ritual_praxis_text_box}>
                      <div className={styles.ritual_praxis_text_box_bfr}>
                        <div className={styles.border_box}></div>

                        <div className={styles.ritual_praxis_text_box_bfr}>
                          <p>
                            In this belief system they teach that one receives
                            personal revelation about the future directly
                            through a relationship to God. They teach that those
                            holding the priesthood may experience visions of
                            light and truths revealed through dreams. Their
                            priesthood holders are given personal power, equal
                            to their God, to heal and bless others. They have
                            magical garments with special symbolic markings to
                            protect them from evil forces. Each local group has
                            a <span>“Patriarch”</span> who acts like a shaman
                            and diviner and fortune teller. They can see what
                            one’s spiritual lineage is from the tribes of
                            Israel. They see into their future revealing one’s
                            mission in life. In their cosmology you progress to
                            the highest of glory and become an actual god
                            yourself. They say their god was once a man. All
                            very esoteric ideas, but most of them borrowed and
                            modified.
                          </p>

                          <p>
                            Both my parents had several supernatural experiences
                            credited to their beliefs which they shared with us.{" "}
                            <span>
                              My mother’s stories seemed impossible and
                              fantastic, but I believed her
                            </span>
                            . My father would quite often have visions at night
                            while dreaming just to gather the family the next
                            day to proclaim their significance. Quite the ripe
                            breeding ground for developing interests in the
                            occult. Although now I saw these practices as basic
                            and corrupt, I was already steeped in the ideas of
                            special powers, initiations, and a secret system of
                            progression. From the outside, these occult
                            connections are not so clear and their missionaries
                            are all over the world even today. This religion is
                            known throughout the world as Mormonism or the
                            Church of Jesus Christ of Latter Day Saints. Just a
                            simple Google search will reveal to the seeker that
                            their earliest beginnings were steeped in folk
                            religion, magic and the occult. We talk a lot more
                            about this in our essay on Joseph Smith, their
                            founder, here on our website.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.teachers_blk5_main_wrapper}>
          <div className={styles.common_1width}>
            <div
              className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle} `}
            >
              <span className={styles.column}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h1>I WAS FIRST EXPOSED TO MAGICK AT THE AGE OF 16</h1>
                </div>
              </span>
            </div>
          </div>
          <div className={styles.full_block5_wrapper}>
            <div className={styles.common_width}>
              <div className={styles.ritual_praxis_main_body}>
                <div className={styles.block1_full_width}>
                  <div className={styles.ritual_praxis_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                        className={styles.block1_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_block5_1st_img.webp"
                      /> */}
                      <img className={styles.block1_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_block5_1st_img.webp`} />
                    </div>
                    <div className={styles.ritual_praxis_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.ritual_praxis_text_box_bfr}>
                        <p>
                          At 16 years old, when visiting a friend’s home in the
                          small town of Saint Anthony Idaho, I was first exposed
                          to Theurgy through{" "}
                          <span>“The Confessions of Aleister Crowley”</span>.
                          Crowley’s version of Theurgy was termed{" "}
                          <span>“High Magick”</span>. My friend “dared” me to
                          read the book like it was some kind of spooky cursed
                          tablet. I was honestly just more curious than anything
                          else, I had not been exposed to many things outside of
                          Mormonism at this point. I found that I couldn’t put
                          the book down and I poured through it in less than a
                          month (984 page book!) During my reading, several
                          memories of PSI experiences I had as a child were
                          triggered and so many things were at least somewhat
                          explained. I was hooked and the second book I read was
                          Francis King’s{" "}
                          <span>“Techniques in High magick ''</span> the summer
                          I turned 17. This was the first book where I found
                          some practical application of the art. From here I
                          bought my first Tarot card set (Thoth) at the age of
                          18 and began studying divination and Tarot symbolism.
                          From here I began reading everything I could get my
                          hands on related to spiritual practices, occult
                          science, Tarot, Astrology, Shamanism you name it. From
                          18 I began reading Tarot for myself and others, even
                          renting booths at Saturday markets to read for folks.
                          As of today I have read for myself thousands of times
                          and for others professionally over 500 times.{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.teachers_blk6_main_wrapper}>
          <div className={styles.common_1width}>
            <div
              className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle} `}
            >
              <span className={styles.column}>
                <div className={`${styles.col12} ${styles.bgifive}`}>
                  <h1>THE SUMMUM PYRAMID AND HERMETIC PRINCIPLES</h1>
                </div>
              </span>
            </div>
          </div>

          <div className={styles.full_block6_wrapper}>
            <div className={styles.common_width}>
              <div className={styles.ritual_praxis_main_body}>
                <div
                  className={`${styles.block2_full_width} ${styles.block2_new_full_width}`}
                >
                  <div
                    className={`${styles.ritual_praxis_box_wrpr2} ${styles.ritual_praxis_box_wrpr3}`}
                  >
                    <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                      {/* <img
                        className={styles.block2_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_block6_1st_img_new.webp"
                      /> */}

                      <img className={styles.block2_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_block6_1st_img_new.webp`} />
                    </div>
                    <div className={styles.ritual_praxis_text_box}>
                      <div className={styles.ritual_praxis_text_box_bfr}>
                        <div className={styles.border_box}></div>

                        <div className={styles.ritual_praxis_text_box_bfr}>
                          <p>
                            Having moved to Salt Lake City Utah at the age of
                            18, I was sleeping on the couch of a friend late
                            into the morning one day. I had a vision in a dream
                            and saw a book that I needed to get my hands on. At
                            this time the Golden Braid bookstore was just around
                            the corner from the apartment I was staying at. I
                            saw right where it was sitting on the shelf in my
                            dream, and even the young lady that was working the
                            counter. I shot up and went straight to the
                            bookstore. I only had $11 left to my name and was
                            hoping it was enough to purchase the item. I walked
                            inside and went straight to the shelf where this
                            book was located. This book was Summum{" "}
                            <span>“Sealed Except to the Open Mind”</span>, and I
                            spent the very last money I had to get it. It was
                            exactly $11 and after I explained my dream to the
                            clerk she was kind enough to let me off on the
                            taxes.{" "}
                          </p>

                          <p>
                            This book produced by Summum was an updated version
                            of another book written by William Walker Attkinson
                            almost a century earlier. One that became the most
                            influential work, especially in my earlier spiritual
                            career. This original work was called The Kybalion,
                            an inspired vision of the Hermetic principles of
                            ancient Egypt. Much of my early training in
                            meditation was rooted in this system and its
                            principles. Summum had updated this to a complete
                            vision combining quantum mechanics, string theory
                            and new axioms. It was through this work that I was
                            first exposed to the concept of an{" "}
                            <span>“Infinite Living Mind”</span> in nature which
                            eventually led me to related teachings in the
                            world’s religions and philosophies. At the time I
                            was studying with Summum I had also picked up Liber
                            Aleph by Aleister Crowley, Instant ESP by David St.
                            Clair, WICCA a guide for the solitary practitioner
                            by Cunningham and started reading Carlos Castaneda.
                            It was the Castaneda series that got me interested
                            in more natural Animism, Shamanism and Native
                            American lore.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block1_full_width}>
                  <div className={styles.ritual_praxis_box_wrpr}>
                    <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                      {/* <img
                        className={styles.block1_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_block6_2nd_img.webp"
                      /> */}
                      <img className={styles.block1_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_block6_2nd_img.webp`} />
                    </div>
                    <div className={styles.ritual_praxis_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.ritual_praxis_text_box_bfr}>
                        <p>
                          I went through all the required programs and was
                          initiated into Summum where I began attending all
                          their events. This was the first time I was exposed to
                          the true transmutation and talismanic power of
                          concentrated thought. Summum had built a two story
                          Pyramid right in the heart of Salt Lake City. Within
                          their pyramid was a gigantic wine vat that their more
                          adept members would meditate on for days and even
                          weeks. They instilled vibratory energy into the wine
                          while it was fermenting as they concentrated on a
                          specific vibration of <span>“state change”</span>.
                          They had different types of wines that they produced,
                          but all under the title of{" "}
                          <span>“Nectar Publications”</span>. After turning 21 I
                          worked with these quite a bit in my meditation
                          practices. When you would open the wine, there were
                          always sugar crystals in the shape of tiny pyramids
                          under the cork and settled at the bottom. These wines
                          were so powerful that just a sip would place you in an
                          altered state. Hard to explain without trying this
                          yourself, the closest I could say it was similar to
                          the effects of microdosing psychoactive mushrooms.
                        </p>

                        <p>
                          Working with the Summum group I learned the discipline
                          of thought, the ability to connect with the mind of
                          nature, and a dedication to the practice of
                          meditation. I built a special relationship with Sue,
                          the main teacher who initiated me into the order. I
                          would go to the Pyramid grounds and mow lawns, rake
                          leaves and whatever else I could out of appreciation.
                          This allowed me a lot of extra time with the other
                          instructors as well. This was a real pivot in my
                          dedication to spiritual practices and I sent time
                          there between the ages of 18 and 22. I still keep in
                          touch with them today.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className={styles.block2_full_width}>
                  <div className={styles.ritual_praxis_box_wrpr2}>
                    <div
                      className={`${styles.img_box} ${styles.trfm_Y1}  ${styles.trfm_Y2}`}
                    >
                      {/* <img
                        className={styles.block3_part1_img}
                        src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_block6_3rd_img_new.webp"
                      /> */}
                      <img className={styles.block3_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_block6_3rd_img_new.webp`} />
                    </div>
                    <div className={styles.ritual_praxis_text_box}>
                      <div className={styles.border_box}></div>
                      <div className={styles.ritual_praxis_text_box_bfr}>
                        <p>
                          <span>
                            When I was 23 I joined as a correspondence student
                            of B.O.T.A
                          </span>
                          ., a Golden Dawn based western mystery school. This is
                          where I came across Paul Foster Case’s work and he, as
                          well, incorporated the Kybalion. Aside from
                          myself-study into Crolwey’s Thoth Tarot this was my
                          first serious large-scale undertaking in the study of
                          esoteric Tarot philosophy.{" "}
                          <span>
                            I would receive in the mail a packet every month
                            associated with a particular Tarot card
                          </span>
                          . We had to study and participate, including the
                          coloring of our own Tarot based on their symbolism. I
                          remained a member of B.O.T.A. for three years studying
                          many of their publications and listening to their
                          entire tape series. Paul Foster Case, even today, is
                          considered one of the foremost authors on the
                          esoteric, especially Tarot. This sent me on an even
                          deeper Tarot journey and I began purchasing everything
                          I could find on the subject. This took me into the
                          world of divination generally and I studied dozens of
                          different methods including I-Ching and Rune stones.
                          Since that time, I have worked diligently to master
                          the many facets of Tarot divination, divination in
                          general and its many references throughout history.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ----------------------------------------------------------****************--------------------------------------- */}
      {/* -----------------------------------------------------------------biswarup-start------------------------------------------------------------------ */}

      <div
        className={`${styles.block1_main_wrpr} ${styles.block1_main_wrpr_part7}`}
      >
        <div className={styles.common_width}>
          <div
            className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
          >
            <div className={styles.column}>
              <div className={`${styles.col12} ${styles.bgifive}`}>
                <h1>EARLY EXPERIENCE WITH THE SHAMANIC ARTS</h1>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.full_block_wrapper}>
          <div className={styles.common_width}>
            <div className={styles.teachers_details_main_body}>
              <div className={styles.block1_full_width}>
                <div className={styles.teachers_details_box_wrpr}>
                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    {/* <img
                      className={styles.block1_part1_img}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_details_part7_block1_left_img.webp"
                    /> */}
                    <img className={styles.block1_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_details_part7_block1_left_img.webp`} />
                  </div>
                  <div className={styles.teachers_details_text_box}>
                    <div className={styles.border_box}></div>
                    {/* <div className={styles.yellow_heading}>
                      <h1>School of Our Divine Infinite Being</h1>
                    </div> */}
                    <div className={styles.teachers_details_text_box_bfr}>
                      <p>
                        As mentioned above, I had a wide variety of spiritual
                        interests, especially early on. Throughout my 20s I was
                        mixing theurgy, ritual drumming, and pursued a high
                        interest in the effects of dance and trace. For a time I
                        offered drum healing sessions after I threw Tarot to
                        discover the energetic needs of a participant. After
                        reading Casteneda I started passionately studying
                        Shamanism including several serious anthropological
                        studies and academic research.{" "}
                        <span>
                          A big part of what drove this experience was the hours
                          I spentevery weekend drumming and dancing in the
                          burning sun
                        </span>
                        . With some other drummers and eventually several
                        dancers we started a phenomenon inLiberty Park in Salt
                        Lake City that persists to this day. We began a weekly
                        drum circle that eventually filled with over 30 drummers
                        andtwice that many spectators and dancers. It grew
                        larger every week and on one occasion we were able to
                        hold hands and surround the entirepark section we met
                        at.{" "}
                        <span>
                          After the three years I attended there must have been
                          over 400 participants and north of 50+ drummers
                        </span>
                        . Many ofthe same faces came every week and the drumming
                        became more organized and rhythmic. The energy was
                        incredible. I began switching off drumming with dancing
                        and being as involved in shamanism as I was at the
                        time,I focused my energy on the ecstasy and vision work
                        I was reading about. After a time, I began to have
                        powerful lucid visions during theseevents.
                      </p>

                      <p>
                        I had a chance to work with three different native
                        shamans from local tribes in the area. One was a Native
                        American healer living in Salt Lake I had heard a lot
                        about. I paid what little money I had at the time for
                        his council. Instead of any healing sessions as he
                        normally did, at my request he spent the time teaching
                        me how to perform Native American ceremonies. A Shoshone
                        woman traditionally trained as a shaman helped me dig
                        and build my first sweat lodge in my backyard. She
                        taught me about the purpose andspiritual experiences of
                        a sweat ceremony and taught me how to conduct one. I
                        made use of this lodge mostly alone but at times would
                        host others over the six months I lived there. The
                        third,surprisingly enough, ended up being my neighbor in
                        a duplex I lived in. He was the Medicine Man for three
                        tribes including the Bannock ofEastern Idaho who were
                        local to me growing up.{" "}
                        <span>
                          He was living in Salt Lake City selling his t-shirt
                          art and sending the money earned backto his people
                        </span>
                        . We would spend many nights sitting on the porch
                        together talking about the native American healing arts
                        and the nature oflife. These were some of my favorite
                        evenings and memories and I was lucky to have this
                        council for the months we lived as neighbors.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${styles.block1_main_wrpr} ${styles.block1_main_wrpr_part8}`}
      >
        <div className={styles.common_width}>
          <div
            className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
          >
            <div className={styles.column}>
              <div className={`${styles.col12} ${styles.bgifive}`}>
                <h1>
                  MY UCMT EDUCATION AND THE TEACHERS <br></br>THAT APPEARED
                  BEFORE ME
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.full_block_wrapper}>
          <div className={styles.common_width}>
            <div className={styles.teachers_details_main_body}>
              <div
                className={`${styles.block2_full_width} ${styles.part8_block2_full_width}`}
              >
                <div className={styles.teachers_details_box_wrpr2}>
                  <div className={`${styles.img_box} ${styles.trfm_Y1}`}>
                    {/* <img
                      className={styles.block2_part1_img}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_details_part8_block1_right_img.webp"
                    /> */}
                    <img className={styles.block2_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_details_part8_block1_right_img.webp`} />
                  </div>
                  <div className={styles.teachers_details_text_box}>
                    <div className={styles.teachers_details_text_box_bfr}>
                      <div className={styles.border_box}></div>
                      <p>
                        In 1995 I attended UCMT, which at the time was the
                        second top school in the world for holistic body work. I
                        graduated at the top of my class and began an energy
                        medicine and holistic body work practice that I managed
                        privately for many years. In and out of school I have
                        worked with over 300 clients providing a variety
                        ofdifferent healing modalities. I was trained in
                        advanced massage therapy (several forms), hydrotherapy,
                        deep tissue massage, anatomy/physiology, advanced
                        structural realignment, several energy modalities,
                        craniosacral therapy, acupressure, shiatsu, Feldenkrais,
                        chi-gong and kundalini yoga.Although through my earlier
                        training in Theurgy I was already working with the{" "}
                        <span>“body of light”</span> it was at school where my
                        interest in the human energy field really took off.
                      </p>

                      <p>
                        While at school I had many wonderful teachers in various
                        subject matters. Surprisingly, the mentors that had the
                        largest impact on me were not faculty. One was a woman
                        there as a student trained in several energy modalities,
                        was in her 60s and had continuously attended different
                        colleges for the last 30 years. She had certificates and
                        graduate degrees in numerous subjects from both
                        traditional and alternative colleges from all over the
                        world. Up until my meeting with her I already had ample
                        experiences with the humanenergy field and understood
                        much about it in my studies. She saw something different
                        in me that I had yet to discover myself. Sheintuitively
                        recognized my ability to see the human energy field.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={`${styles.block3_full_width} ${styles.part8_block3_full_width}`}
              >
                <div className={styles.teachers_details_box_wrpr}>
                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    {/* <img
                      className={styles.block3_part1_img}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_details_part8_block2_left_img.webp"
                    /> */}
                    <img className={styles.block3_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_details_part8_block2_left_img.webp`} />
                  </div>
                  <div className={styles.teachers_details_text_box}>
                    <div className={styles.border_box}></div>
                    {/* <div className={styles.yellow_heading}>
                      <h1>School of Our Divine Infinite Being</h1>
                    </div> */}
                    <div className={styles.teachers_details_text_box_bfr}>
                      <p>
                        Through a series of events, she demonstrated how to see,
                        interact, and work with the field. This all started one
                        day in class when we were watching a student walk to
                        determine where she was holding too tight in her
                        muscular system. She put her arm on my shoulder and
                        pointed toward her knee and said “look”. There was
                        aniridescent fountain rising from the student’s knee.
                        She then instructed me to go and ask her about this. She
                        had injured and tore her knee terribly in a sports
                        injury and was still suffering. Fromthere she taught me
                        on the side during school to recognize color, vibrance,
                        sickness, strong fields and those that are
                        suffering.Included in her instruction was the ability to
                        see photosynthesis and the geomagnetic field in nature
                        (Something I teach in our retreats).{" "}
                        <span>
                          During the six months I was in school she spent at
                          least ⅓ of that time teaching me selflessly
                        </span>
                        .
                      </p>

                      <p>
                        The second teacher was my after-class Kundalini Yoga
                        instructor. He spent many days after class speaking to
                        me about the rise of energy and what kundalini was
                        about. I went to his class every day after school so I
                        was trained for a full six months in Kundalini Yoga from
                        this incredible person.{" "}
                        <span>
                          This is what led me on an academic path learning
                          everything I could about Tantra and Kundalini Yoga
                        </span>
                        . This led me to a total integration of Eastern
                        Principles into my Theurgic practices. As I knew that
                        Aleister Crowley’s order also combined Eastern practices
                        I was led during school as well to studying as much of
                        his work as I could find. To my surprise William Walker
                        Atkinson, the author of the Kybalion, had also written
                        extensively on Eastern ideas. I spent much of the next
                        decade getting to know every written work of Atkinsonand
                        most of Crowleys. It was this decade as well that I
                        began practicing ritual theurgy following after Crolwey
                        and other occultists Iwas reading at the time.{" "}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${styles.block1_main_wrpr} ${styles.block1_main_wrpr_part9}`}
      >
        <div className={styles.common_width}>
          <div
            className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
          >
            <div className={styles.column}>
              <div className={`${styles.col12} ${styles.bgifive}`}>
                <h1>MY AWAKENING WHILE ATTENDING UCMT</h1>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.full_block_wrapper}>
          <div className={styles.common_width}>
            <div className={styles.teachers_details_main_body}>
              <div className={styles.block1_full_width}>
                <div className={styles.teachers_details_box_wrpr}>
                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    {/* <img
                      className={styles.block1_part1_img}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_details_part9_block1_left_nw_img.webp"
                    /> */}
                    <img className={styles.block1_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_details_part9_block1_left_nw_img.webp`} />
                  </div>
                  <div className={styles.teachers_details_text_box}>
                    <div className={styles.border_box}></div>
                    {/* <div className={styles.yellow_heading}>
                      <h1>School of Our Divine Infinite Being</h1>
                    </div> */}
                    <div className={styles.teachers_details_text_box_bfr}>
                      <p>
                        During school I was going through something
                        energetically that was causing many things to start
                        accelerating in my life. I was doing several hours of
                        bodywork and practice during the day at school and then
                        studied for hours in my parking booth job where I had
                        lots of free time. I was completely inundated with
                        energy work and study into theurgy, Shamanism and the
                        occult for most of my waking hours. I could feel that
                        something significant was beginning to shift for me. Not
                        all positive, including the loss of friends, trouble
                        with sleep, some intense flu like symptoms and other
                        disturbances that seemed to not give me a day off. I
                        could tell something was “cleaning out” in my psyche.
                      </p>

                      <p>
                        Then one day it all cumulated. I was sitting in the back
                        of anatomy and physiology class and suddenly everyone’s
                        energy body just lit up all at once. Before I would have
                        to concentrate to see it, but it had become fully
                        visible on all the 40 or so class members. The teacher,
                        a staunch disbeliever in energy medicine and the anatomy
                        professor from the nearby university had a sickening
                        green color on his back. I went up to him as class was
                        leaving and said,{" "}
                        <span>
                          “You’re sick, something is wrong with your back”
                        </span>
                        . He wide eyed looked at me and stated{" "}
                        <span>
                          “That is correct. I have issues with my spine, and I
                          experience a lot of pain.”
                        </span>{" "}
                        The look on this face was absolute disbelief. He had not
                        told anyone this.
                      </p>

                      <p>
                        Upon leaving the building and getting outside I was in
                        shock. I could see the geomagnetic field around every
                        living thing without any effort. So much that I felt
                        like I was on some alien planet.{" "}
                        <span>
                          The trees, bushes, animals, people, anything with life
                          was all connected by this field and surrounded by it
                        </span>
                        . I could see energy globules photosynthesizing in mass
                        by vegetation and leaves on all the trees. I could feel
                        this intense unified field that was surrounding me on
                        all sides. To this day I credit this moment to a
                        Kundalini awakening from all my intense body work and
                        deep concentrated study at the time. Since that day I am
                        still able to see and work with these fields and have
                        much more control over them. As far out as this may
                        sound, I have been able to teach my students to see and
                        experience these in just a weekendretreat.
                      </p>

                      <p>
                        During the same year I started school I became close
                        friends with a long-standing member of the O.T.O. This
                        is the name of one of the magical organizations based on
                        the Thelemic philosophies of Aleister Crowley. He and I
                        embarked on a series of rituals, Tarot work and long
                        into the night discussion about Theurgy and the nature
                        of reality. My interest in Theurgy was greatly
                        increasing and I began experiencing the grandeffects of
                        ritual like never before.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`${styles.block1_main_wrpr} ${styles.block1_main_wrpr_part10}`}
      >
        <div className={styles.common_width}>
          <div
            className={`${styles.countDiv} ${styles.titleblock} ${styles.withsubtitle}`}
          >
            <div className={styles.column}>
              <div className={`${styles.col12} ${styles.bgifive}`}>
                <h1>I BEGAN DEEPER MAGICAL PRACTICE AT THE AGE OF 20</h1>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.full_block_wrapper}>
          <div className={styles.common_width}>
            <div className={styles.teachers_details_main_body}>
              <div className={styles.block1_full_width}>
                <div className={styles.teachers_details_box_wrpr}>
                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    {/* <img
                      className={styles.block1_part1_img}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_details_part10_block1_left_img.webp"
                    /> */}
                    <img className={styles.block1_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_details_part10_block1_left_img.webp`} />
                  </div>
                  <div className={styles.teachers_details_text_box}>
                    <div className={styles.border_box}></div>
                    {/* <div className={styles.yellow_heading}>
                      <h1>School of Our Divine Infinite Being</h1>
                    </div> */}
                    <div className={styles.teachers_details_text_box_bfr}>
                      <p>
                        I continued to study and practice every day and built my
                        first ritual chamber in the basement of my house just
                        before starting school in 1995.{" "}
                        <span>
                          I began performing regular pentagram banishing, middle
                          pillar, and other rituals
                        </span>
                        . I started keeping journals, developed personal
                        grimoires, compendiums and got into the habit of regular
                        ceremonial ritual practice. I accumulated quite the
                        library of over 500 titles in the occult, pagan studies,
                        meditation, eastern philosophy, psi science, psychology,
                        shamanism, and western mysteries. I worked at this
                        parking booth for just over four years. This covered the
                        time I was in school while Iwas building my holistic
                        body work practice. The parking lots I worked at were
                        full of monthly subscribers, I mostly just waved
                        aspeople used their cards to get in and out. This gave
                        me hours a day to freely read and study. I poured
                        through hundreds of titles, makingnotes, and taking it
                        all serious as if I were in some invisible college. I
                        filled notebook after notebook with quotes and ideas. I
                        lookedforward to work every day because it had become my
                        sanctuary of study and research.{" "}
                        <span>
                          I was full time and was able to dedicate 80% of mytime
                          to study
                        </span>
                        . I would guess this to have been 5,000+ hours give or
                        take. What a gift I was given so early in my adulthood.
                        It gave methe reading habit that I still work hard to
                        maintain today.
                      </p>

                      <p>
                        Regrettably at the age of 27 I sold my entire library as
                        I was needing to pay for rent and food. Such a sad day
                        as I had many books that today would be considered rare
                        and worth hundreds to thousands of dollars. Since then,
                        I have amassed over 1,600 titles, hundreds of research
                        papers and journals continuing my deep study and that of
                        the school. Although I listen to hundreds of podcasts
                        and research on the internet I always found it important
                        to have a library of actual physical books, which now
                        belongs to the school. Thedepth and possibilities to our
                        current reality are endless, you must study continuously
                        and to this day I still consider myself anenthusiastic
                        student. I have my nose in a book at least once if not
                        several times a day.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.block2_full_width}>
                <div className={styles.teachers_details_box_wrpr2}>
                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    {/* <img
                      className={styles.block2_part1_img}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_details_part10_block2_left_nw_img.webp"
                    /> */}
                    <img className={styles.block2_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_details_part10_block2_left_nw_img.webp`} />
                  </div>
                  <div className={styles.teachers_details_text_box}>
                    <div className={styles.border_box}></div>
                    {/* <div className={styles.yellow_heading}>
                      <h1>School of Our Divine Infinite Being</h1>
                    </div> */}
                    <div className={styles.teachers_details_text_box_bfr}>
                      <p>
                        In 1999 I took off with my then girlfriend in a VW bus
                        to explore the Pacific NorthWest (how I obtained this
                        bus was through a theurgic ritual. Great fireside
                        story). During our trip there I took every opportunity
                        to performTheurgic ritual.{" "}
                        <span>
                          One of the most powerful experiences I ever had was
                          performing the Middle Pillar, a Kabalistic Theurgic
                          ritual developed by Israel Regardie
                        </span>
                        . This happened while we were driving through the
                        40-mile canyon in Northern Idaho. There were mountains
                        and trees vertically on both sides and we stopped
                        somewhere in the middle. I climbed the side of the
                        mountain and did a fullBanishing Pentagram and then the
                        Middle Pillar and closed with another Banishing
                        Pentagram. Pretty usual set for me as I was doing
                        theseat least once a week. This time it was the most
                        intense it has ever been, and it was here that I for the
                        first time fully experienced thespaceless, timeless
                        nature of the body of light. My BIO really isn't the
                        space to talk about the experience, but it was
                        unforgettable andthe beginning of some of my most
                        intense work that followed. I had fully identified with
                        the body of light, finally understanding what Iamblichis
                        meant when he stressed this identification as an
                        absolute necessity.{" "}
                      </p>

                      <p>
                        We ended this trip in Salem Oregon where I took a job as
                        a manager on a shiitake and oyster mushroom farm. We
                        stayed on the farm in our VW bus using the facility
                        showers and laundry. There was a huge open building, and
                        the ownerwas friendly to my practices in Theurgy,
                        surprisingly having some background himself. I was able
                        to utilize the building for ritual andcontinued my
                        practice in the evenings while I was working there.{" "}
                        <span>
                          This was the first fully continuous work daily lasting
                          over 5 full months
                        </span>
                        . What I wasexperiencing was no less than miraculous and
                        powerful as the days drew on through continuous
                        practice. By the time I had gotten 60 daysin I was
                        beginning to experience much higher and elevated forms
                        of ecstatic states of awareness. States you could not
                        reach in a week oreven a month. I was learning from an
                        eternal source, my education was coming from an infinite
                        living mind that I was awakening into. Thiswas such a
                        special time in my life as it was a rebirth into a world
                        I would have never been able to reach without such a
                        dedicatedTheurgic practice. Since that time I have
                        undergone serious long term operations most anywhere
                        from thirty days to six months. To date Ihave practiced
                        ritual in one form or another well into the thousands of
                        times.{" "}
                        <span>Not 100% consistent over time of course</span>,
                        but even withgaps I have had quite the career as a
                        practicing Theurgist.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.block3_full_width}>
                <div className={styles.teachers_details_box_wrpr}>
                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    {/* <img
                      className={styles.block3_part1_img}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_details_part10_block3_left_img.webp"
                    /> */}
                    <img className={styles.block3_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_details_part10_block3_left_img.webp`} />
                  </div>
                  <div className={styles.teachers_details_text_box}>
                    <div className={styles.border_box}></div>
                    {/* <div className={styles.yellow_heading}>
                      <h1>School of Our Divine Infinite Being</h1>
                    </div> */}
                    <div className={styles.teachers_details_text_box_bfr}>
                      <p>
                        After leaving the mushroom farm I moved on to different
                        food service management careers and continued my work in
                        holistic health. In 2000 I put together some of my first
                        classes where I taught in new age and occult bookstores
                        on subjects such as Tarot, Kabbalah and Theurgic ritual.
                        I met one of my lifelong friends at one of my classes,
                        Troy Wenning. Troy was a lot like me, having a wide
                        number of interests, expertise and knowledge of a
                        multitude of subjects.{" "}
                        <span>
                          He and I would meet every morning talking about
                          Theurgy, meditation and spirituality in general
                        </span>
                        . He is still one of my favorite people and we still
                        speak often. What I loved the most was the diversity of
                        our conversations. He was skilled in Astrology, I-Ching,
                        Energy Psychology and the Mayan Cosmology amongst other
                        things. This was my firstopportunity to see the deep
                        connections between multiple systems and it greatly
                        broadened my interests. In 2000, engrossed in my
                        ownTheurgic practices and learning extensively from
                        Troy, I began thinking seriously about the need for a
                        new way of practice. I made a GeoSites website (who
                        remembers them? lol) called{" "}
                        <span>
                          “Merkava Mysticism and The Kabbalistic Cannon of
                          Light.”
                        </span>{" "}
                        At thattime I was very much a Kabalistic Theurgist and
                        fascinated by the earliest Theurgy of the Hebrew
                        peoples. Merkava Mysticism was Theurgy, and it was just
                        a short number of years beforeI figured out it was a
                        surviving ritual practice highly related to the
                        Greco/Roman Theurgy that dominated the Roman Empire just
                        beforethe rise of Christianity. Practices that over two
                        decades led me to the final development of the School of
                        the Divine Infinite Being.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.block4_full_width}>
                <div className={styles.teachers_details_box_wrpr2}>
                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    {/* <img
                      className={styles.block4_part1_img}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_details_part10_block4_left_nw_img.webp"
                    /> */}
                    <img className={styles.block4_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_details_part10_block4_left_nw_img.webp`} />
                  </div>
                  <div className={styles.teachers_details_text_box}>
                    <div className={styles.border_box}></div>
                    {/* <div className={styles.yellow_heading}>
                      <h1>School of Our Divine Infinite Being</h1>
                    </div> */}
                    <div className={styles.teachers_details_text_box_bfr}>
                      <p>
                        I continued to study, work on the format of the school
                        and practice meditation, Theurgy deepening my connection
                        to the Cosmos. Like everyone, there were times I was
                        completely disenchanted and disengaged but for the most
                        part I always turned back to developing the school more.
                        I have invested six figures into the art work,{" "}
                        <span>
                          websites and programs for the school since 2020
                        </span>
                        . Although I made several attempts at afoundational
                        website over the last decade, most everything up to that
                        point was in power points, journals and notebooks. I had
                        reached apoint in 2022 where I was getting a bit
                        discouraged. My regular business is by itself an anomaly
                        and we were breaking records in proprietary software
                        development. I was just so busy. I found the time to
                        read a book called <span>“Psyche and Singularity”</span>{" "}
                        by Timothy Desmond.It was the first time in well over a
                        decade that I read something that was more than just{" "}
                        <span>“another angle”</span>. I reached out to Timothy
                        and he actually came to Idaho and spent time with me.
                        What Ihad been moving towards and working on for the
                        last 20 years suddenly had a perfect parallel with the
                        work of this incredible philosopher and scholar. No need
                        to get into this here. You can read all about Timothy
                        Desmond and his relationship to our school in our
                        CentralDoctrine.
                      </p>

                      <p>
                        As your teacher, whether that be in our formal
                        Astrology/Tarot training, or the inner mystery school,
                        what I have for you is experience. Spiritual training,
                        Theurgy, meditation and one’s relationship to the
                        totality state of existence is something I have simply
                        taken seriously my entire life. I was born in 1975. You
                        do that math :)
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.block5_full_width}>
                <div className={styles.teachers_details_box_wrpr}>
                  <div className={`${styles.img_box} ${styles.trfm_Y}`}>
                    {/* <img
                      className={styles.block5_part1_img}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_details_part10_block5_left_nw_img.webp"
                    /> */}
                    <img className={styles.block5_part1_img} src={`${process.env.cloud_url2}teachers_details/teachers_details_part10_block5_left_nw_img.webp`} />
                    {/* <img
                      className={styles.block5_part2_img}
                      src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/teachers_details/teachers_details_part10_block5_left_nw_img_1199v.webp"
                    /> */}
                    <img className={styles.block5_part2_img} src={`${process.env.cloud_url2}teachers_details/teachers_details_part10_block5_left_nw_img_1199v.webp`} />
                  </div>
                  <div className={styles.teachers_details_text_box}>
                    <div className={styles.border_box}></div>
                    {/* <div className={styles.yellow_heading}>
                      <h1>School of Our Divine Infinite Being</h1>
                    </div> */}
                    <div className={styles.teachers_details_text_box_bfr}>
                      <h4>AMONG MUCH OF THE SUCCESS I HAVE EXPERIENCED IS:</h4>

                      <h3>
                        Crafting, formulating, and casting hundreds of spells
                        healing myself and others of disease.
                      </h3>

                      <h3>
                        Perceiving the auric fields of light around people and
                        the geo-magnetic fields found in nature.
                      </h3>

                      <h3>
                        The working with the archetypal forces of Astrology and
                        other Deities agnostically
                      </h3>

                      <h3>
                        Perceiving photosynthesis directly in several natural
                        settings.
                      </h3>

                      <h3>
                        Seeing into future events on several occasions through
                        dreams
                      </h3>

                      <h3>
                        Witness to fantastic revelations in visions of light{" "}
                        <span>(eternal spiritual pedia)</span>
                      </h3>

                      <h3>
                        Experiencing and manipulating the astral light to
                        manifest circumstances and events
                      </h3>

                      <h3>
                        Empowering crystals, sigils, talismans, amulets, and
                        other objects
                      </h3>

                      <h3>
                        Divining current and future circumstances through Tarot
                        and direct visionary ritual
                      </h3>

                      <h3>
                        Manifesting people into my life needed for my specific
                        path
                      </h3>

                      <h3>
                        Purifying, empowering and creating incredible change in
                        personality
                      </h3>

                      <h3>
                        Experiencing psychokinetic influences with fire and
                        other natural objects
                      </h3>

                      <h3>
                        Some exploration into remote viewing and clairaudience
                      </h3>

                      <h3>
                        Connecting with the currents and Geo-magnetic fields of
                        nature
                      </h3>

                      <h3>
                        Invoking the spirits of nature and their vast archetypal
                        agency
                      </h3>

                      <h3>
                        Witnessing to the immortality of our undying
                        indestructible nature
                      </h3>

                      <p>
                        I hope to see you study other aspects of our school
                        besides my personal history and practice. A great place
                        to start is in our Central Doctrine.{" "}
                        <Link href="/central-doctrine">
                          <strong>Click here</strong>
                        </Link>
                        .
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* -----------------------------------------------------------------biswarup-end------------------------------------------------------------------ */}
      {/* ----------------------------------------------------------****************--------------------------------------- */}

      {/* -----------------------------------------modal---------------------------------- */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main"
      >
        <Box className="banner_modal_box">
          <Typography
            id="modal-modal-description" component="div"
            sx={{ mt: 2 }}
            className="modal_banner"
          >
            <div className="sub_modal_banner">
              <span className="close_btn" onClick={handleClose}>
                <CloseIcon />
              </span>
              <img
                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                alt="bannerLogo"
              />
            </div>
          </Typography>
        </Box>
      </Modal>
    </>
  );
}
